import styled from "styled-components";

export const Wrapper = styled.div`
  .addButton {
    display: flex;
  }
  .data-check-icon {
    background: green;
    border-radius: 50%;
    color: white;
    font-size: 11px;
    padding: 6px;
  }
  .data-cross-icon {
    background: #cb0a0a;
    border-radius: 50%;
    color: white;
    font-size: 11px;
    padding: 6px;
  }

  .delete-icon {
    margin-left: 10px;
  }
`;
